/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SeminarRegistrationStatus {
    PENDING = 'pending',
    CONFIRMED = 'confirmed',
    WAITLIST = 'waitlist',
    CANCELLED = 'cancelled',
    REJECTED = 'rejected',
}
